import type { SVGMotionProps } from 'framer-motion';
import { motion } from 'framer-motion';
import { useId } from 'react';

export function ChallengeCheckIcon(
  props: Omit<SVGMotionProps<SVGSVGElement>, 'children'>,
) {
  return (
    <motion.svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        color: '#6342cc',
        height: 'auto',
        verticalAlign: 'top',
        width: 24,
      }}
      {...props}
    >
      <path
        d="M58.304 20.847c5.5 1.247 6.155 3.86 2.052 7.656-1.285 1.32-1.93 1.935-1.907 2.526.022.6.73 1.176 2.151 2.436 4.37 3.47 3.786 6.025-1.497 7.635-1 .36-2.688.971-2.903 1.452-.042.846.442 1.994.951 3.202.808 1.917 1.68 3.986.616 5.246-.876 1.367-3.058 1.148-5.103.943-1.34-.134-2.621-.262-3.438.065-.41.752-.472 2-.537 3.311-.103 2.075-.214 4.308-1.72 4.984-1.36.837-3.23-.31-4.977-1.381-1.167-.716-2.28-1.398-3.15-1.435-.75.48-1.363 1.621-2.004 2.816-.958 1.785-1.98 3.69-3.625 3.686-1.642.173-2.86-1.708-3.99-3.455-.714-1.103-1.394-2.152-2.124-2.598-.863.128-1.902.873-2.99 1.655-1.67 1.198-3.456 2.48-4.9 1.739-1.538-.553-1.81-2.75-2.064-4.8-.164-1.321-.32-2.582-.804-3.3-.836-.245-2.089-.024-3.4.208-2.037.36-4.215.746-5.196-.556-1.115-1.14-.422-3.204.23-5.146.435-1.295.851-2.536.7-3.41-.244-.438-1.936-.91-2.958-1.185-5.5-1.246-6.154-3.86-2.052-7.655.748-.75 1.978-2.004 1.97-2.505-.306-.801-1.267-1.65-2.278-2.542C1.807 29.072.14 27.6.55 26.037c.198-1.625 2.283-2.38 4.228-3.084 1.252-.453 2.446-.886 3.043-1.515.042-.847-.442-1.995-.951-3.203-.808-1.917-1.68-3.986-.616-5.245.87-1.365 3.052-1.147 5.098-.943 1.342.134 2.626.262 3.443-.066.404-.748.466-1.99.532-3.296.104-2.079.216-4.321 1.725-4.999 1.358-.859 3.24.3 4.995 1.381 1.163.716 2.27 1.398 3.132 1.436.544-.146 1.385-1.697 1.933-2.724 2.408-5.045 5.037-4.96 7.773-.208 1.032 1.552 1.489 2.319 2.069 2.427.583.11 1.291-.446 2.833-1.535 4.35-3.474 6.72-2.349 7.125 3.13.122 1.053.343 2.857.768 3.166.836.246 2.089.024 3.4-.208 2.037-.36 4.215-.745 5.197.556 1.114 1.14.421 3.205-.23 5.146-.436 1.296-.852 2.537-.7 3.41.243.438 1.935.91 2.957 1.185Z"
        fill="currentColor"
      />
      <path
        d="M47.045 18.685a5.511 5.511 0 0 1 .207 7.792L26.229 48.644 14.557 36.488a5.513 5.513 0 0 1 7.953-7.635l3.67 3.822 13.072-13.783a5.513 5.513 0 0 1 7.793-.207Z"
        fill="white"
      />
    </motion.svg>
  );
}

export function CoinIcon({
  className,
  style,
}: {
  className?: string | undefined;
  style?: React.CSSProperties | undefined;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      style={style}
    >
      <path fill="#FFCF0D" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" />
      <path
        fill="#FFF19E"
        fillRule="evenodd"
        d="M1.562 12.741 12.716 1.587a7.983 7.983 0 0 0-.684-.454L1.108 12.057c.14.236.291.464.454.684ZM3.917 14.877 14.88 3.913a8.035 8.035 0 0 0-1.159-1.507L2.41 13.719c.454.443.96.832 1.508 1.158Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M13.362 8.553a4.986 4.986 0 0 1-8.828 3.175 4.986 4.986 0 0 0 7.504-6.56 4.973 4.973 0 0 1 1.324 3.385Z"
        opacity=".5"
      />
      <path
        fill="#DBAD09"
        d="M8 14.018A5.937 5.937 0 1 0 8 2.144a5.937 5.937 0 0 0 0 11.874Z"
      />
      <path
        fill="#B78D06"
        d="M12.465 4.2a5.919 5.919 0 0 0-8.347 8.347A5.919 5.919 0 1 1 12.465 4.2Z"
      />
      <path
        fill="#FFDE49"
        d="M10.055 6.058a.897.897 0 0 1 1.236 0c.15.144.234.328.252.517v.004c.005.05.005.1 0 .15v3.188c0 .13-.041.25-.113.35a.677.677 0 0 1-.551.274H5.117c-.368 0-.665-.279-.665-.624V6.694a.825.825 0 0 1 .256-.628.897.897 0 0 1 1.236 0l2.178 1.855 1.933-1.863Z"
      />
      <path
        fill="#FFF19E"
        fillRule="evenodd"
        d="M5.549 10.538h2.325l3.67-3.67v-.143a.809.809 0 0 0 0-.149v-.004a.827.827 0 0 0-.253-.517.897.897 0 0 0-1.237 0l-.62.598-3.885 3.885ZM4.451 8.672V9.81L7.16 7.102l-.615-.524L4.45 8.672Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M13.58 4.548c.025-.104.173-.104.198 0l.305 1.248a.102.102 0 0 0 .075.075l1.248.305c.104.026.104.174 0 .199l-1.248.305a.102.102 0 0 0-.075.075l-.305 1.248c-.025.104-.173.104-.198 0l-.306-1.248a.102.102 0 0 0-.075-.075l-1.248-.305c-.103-.025-.103-.173 0-.199l1.248-.305a.102.102 0 0 0 .075-.075l.306-1.248Z"
      />
    </svg>
  );
}

export function EarthGlobeIcon({
  style,
}: {
  style?: React.CSSProperties | undefined;
}) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M35.5078 17.5078C35.5078 27.1771 27.6693 35.0156 18 35.0156C8.3307 35.0156 0.492188 27.1771 0.492188 17.5078C0.492188 7.83852 8.3307 -9.34734e-08 18 -2.08779e-07C27.6693 -3.24084e-07 35.5078 7.83852 35.5078 17.5078Z"
        fill="#38B0FF"
      />
      <path
        d="M0.4922 17.5078C0.492407 13.0677 2.17985 8.79352 5.21287 5.55074C8.08797 2.47679 11.9685 0.547372 16.1384 0.102076C16.5874 0.0541292 17.0375 0.160506 17.4307 0.382571L18.325 0.887707C18.4994 0.986192 18.6072 1.17094 18.6072 1.3712C18.6072 1.54605 18.5249 1.71069 18.3849 1.81555L17.5642 2.4306C17.3226 2.61169 17.0288 2.70957 16.7268 2.70957L16.5889 2.70957C16.3086 2.70957 16.0397 2.82037 15.8409 3.01782C15.642 3.21526 15.3731 3.32607 15.0928 3.32607L14.043 3.32607C13.5992 3.32607 13.1733 3.50147 12.8582 3.81407L12.8111 3.86081C12.5228 4.14678 12.3607 4.53602 12.3607 4.94207C12.3607 5.34786 12.1987 5.73687 11.9108 6.0228L9.4255 8.4908C9.10636 8.80771 8.92689 9.23888 8.92689 9.68863L8.92689 10.1187C8.92689 10.2937 8.85697 10.4615 8.73268 10.5847L8.67362 10.6433C8.58713 10.729 8.53848 10.8457 8.53848 10.9675C8.53848 11.2197 8.7429 11.4241 8.99506 11.4241L9.40936 11.4241C9.63916 11.4241 9.85964 11.5149 10.0228 11.6768L10.2953 11.9472C10.633 12.2823 11.0895 12.4703 11.5652 12.4703L12.6828 12.4703C13.1466 12.4703 13.5225 12.8463 13.5225 13.31C13.5225 13.5339 13.4332 13.7484 13.2743 13.9061L13.0401 14.1385C12.7182 14.4579 12.7184 14.9786 13.0407 15.2977C13.1935 15.4491 13.3999 15.534 13.615 15.534L14.4062 15.534C14.6633 15.534 14.9191 15.5702 15.1661 15.6415L15.8018 15.825C16.2253 15.9473 16.6639 16.0093 17.1047 16.0093C18.3447 16.0093 19.5345 16.4996 20.4145 17.3733L22.7046 19.6469C22.837 19.7784 22.9115 19.9573 22.9115 20.1439C22.9115 20.5861 22.5067 20.9176 22.0732 20.8305L21.1964 20.6542C20.8327 20.5811 20.5115 20.3697 20.3004 20.0646L19.8832 19.4613C19.7266 19.2348 19.5418 19.0292 19.3334 18.8493L18.9043 18.4792C18.5263 18.153 18.0437 17.9736 17.5445 17.9736L15.9092 17.9736C15.6627 17.9736 15.4629 18.1734 15.4629 18.4199C15.4629 18.5855 15.5545 18.7374 15.7009 18.8147L16.5588 19.2675C17.0224 19.5121 17.375 19.9247 17.5444 20.4207L17.683 20.8266C17.8774 21.4243 17.7186 22.0806 17.2724 22.5234L16.981 22.8125C16.4999 23.2898 15.8349 23.5343 15.1592 23.4821L14.8144 23.4555C14.1669 23.4055 13.5582 23.1269 13.0972 22.6695L12.2363 21.8154C11.6449 21.2286 10.6908 21.229 10.0998 21.8163C9.81352 22.1009 9.65251 22.4879 9.65251 22.8916L9.65251 22.9776C9.65251 23.4369 9.46903 23.8773 9.14285 24.2007L9.1322 24.2113C8.7992 24.5415 8.61189 24.991 8.61189 25.46L8.61189 25.6734C8.61189 26.2787 8.37022 26.859 7.94055 27.2854L5.48119 29.7257C5.47892 29.728 5.47584 29.7293 5.47263 29.7293C5.46936 29.7293 5.46622 29.7279 5.46393 29.7256C2.27173 26.4606 0.486728 22.0742 0.4922 17.5078Z"
        fill="#007D41"
      />
      <path
        d="M21.9792 12.819C21.6305 12.7941 21.334 13.0703 21.334 13.4198C21.334 13.485 21.3446 13.5498 21.3654 13.6116L21.6539 14.4704C21.7814 14.8499 22.0624 15.1584 22.4284 15.3207C22.6454 15.4169 22.835 15.5658 22.98 15.7537L23.4611 16.3774C23.6218 16.5857 23.763 16.8083 23.883 17.0425C24.1578 17.5788 24.5423 18.0513 25.0117 18.4293L26.5178 19.6422C26.605 19.7125 26.684 19.7924 26.7532 19.8805L26.8268 19.9739C27.0993 20.3205 27.532 20.5009 27.97 20.4505L28.4879 20.3909C28.8338 20.3512 29.0948 20.0584 29.0948 19.7103C29.0948 19.6093 29.0725 19.5096 29.0295 19.4183L28.228 17.7167C27.7459 16.6931 26.9199 15.8711 25.894 15.3939L25.7676 15.3351C25.2191 15.08 24.7322 14.7092 24.3404 14.2483L23.5397 13.3065C23.3219 13.0503 23.0103 12.8925 22.6749 12.8686L21.9792 12.819Z"
        fill="#007D41"
      />
      <path
        d="M30.3758 22.6963C30.1154 22.3145 29.5635 22.2841 29.2627 22.635C29.1537 22.7622 29.0938 22.9243 29.0938 23.0918L29.0938 26.4507C29.0938 26.7852 29.2302 27.1054 29.4717 27.337L29.6475 27.5057C29.8505 27.7005 30.1411 27.7742 30.4125 27.6997C30.7595 27.6044 31.0001 27.2889 31.0001 26.929L31.0001 24.1995C31.0001 23.7719 30.8578 23.3564 30.5956 23.0186L30.3758 22.6963Z"
        fill="#007D41"
      />
      <path
        d="M12.5124 24.4411C12.5438 24.0511 12.1963 23.7376 11.8116 23.8089C11.6721 23.8348 11.5465 23.9097 11.4574 24.0201L9.6717 26.2331C9.49382 26.4536 9.41356 26.737 9.44948 27.018L9.47563 27.2226C9.50585 27.459 9.65812 27.662 9.87653 27.7571C10.1559 27.8788 10.4821 27.7989 10.6734 27.5617L12.1245 25.7633C12.3518 25.4816 12.479 25.1323 12.4858 24.7703L12.5124 24.4411Z"
        fill="#007D41"
      />
      <path
        d="M11.9147 26.3306C11.9461 25.9406 11.5987 25.6271 11.2139 25.6985C11.0744 25.7243 10.9488 25.7992 10.8597 25.9096L9.07404 28.1226C8.89616 28.3431 8.8159 28.6266 8.85182 28.9075L8.87798 29.1121C8.90819 29.3485 9.06046 29.5515 9.27887 29.6467C9.5582 29.7684 9.88442 29.6884 10.0758 29.4512L11.5269 27.6529C11.7542 27.3711 11.8813 27.0218 11.8882 26.6598L11.9147 26.3306Z"
        fill="#007D41"
      />
      <path
        d="M22.6708 24.1622C22.6388 23.8502 22.8162 23.5545 23.1065 23.4359L23.3976 23.3169C23.5306 23.2626 23.6729 23.2346 23.8166 23.2346C24.1088 23.2346 24.3893 23.3502 24.5967 23.556L24.7587 23.7168C24.8916 23.8486 25.0712 23.9226 25.2583 23.9226C25.6501 23.9226 25.9677 24.2401 25.9677 24.6319L25.9677 26.0005C25.9677 26.3218 26.0959 26.6297 26.324 26.856L26.4769 27.0077C26.6071 27.1369 26.6803 27.3127 26.6803 27.4961C26.6803 27.8761 26.3723 28.1841 25.9924 28.1841L25.7664 28.1841C25.5253 28.1841 25.2939 28.2794 25.1227 28.4492L24.5989 28.969C24.4086 29.1578 24.1514 29.2638 23.8832 29.2638L23.2924 29.2638C23.0575 29.2638 22.8672 29.4542 22.8672 29.689C22.8672 29.9239 22.6768 30.1143 22.4419 30.1143L22.3011 30.1143C22.1517 30.1143 22.0083 30.0552 21.9023 29.95L21.815 29.8634C21.478 29.5289 20.9342 29.5289 20.5971 29.8634L20.176 30.2813C20.0248 30.4314 19.8203 30.5156 19.6073 30.5156C19.2739 30.5156 18.9749 30.3108 18.8544 30L18.7779 29.8026C18.5992 29.3415 18.7452 28.8176 19.1368 28.5154L19.8616 27.956C20.0811 27.7866 20.2096 27.525 20.2096 27.2478C20.2096 27.0093 20.3049 26.7807 20.4742 26.6127L20.9472 26.1433C21.0699 26.0216 21.1389 25.856 21.1389 25.6832C21.1389 25.389 21.3371 25.1317 21.6216 25.0566L22.148 24.9177C22.4845 24.8289 22.7063 24.5084 22.6708 24.1622Z"
        fill="#007D41"
      />
    </svg>
  );
}

export function ShopIcon({ className }: { className?: string | undefined }) {
  const clipPathId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fill="#D59B60"
          d="M1.498 6.214c0-.49.397-.889.888-.889h11.227c.49 0 .889.398.889.889v7.406c0 .49-.398.889-.889.889H2.386a.889.889 0 0 1-.888-.889V6.214Z"
        />
        <path
          fill="#CE524B"
          d="m15.875 5.504-1.212-3.257a1.152 1.152 0 0 0-1.075-.747H2.412a1.152 1.152 0 0 0-1.076.747L.124 5.504a1.84 1.84 0 0 0-.04 1.213 2.295 2.295 0 0 0 4.091.544 2.293 2.293 0 0 0 3.825 0 2.293 2.293 0 0 0 3.825 0 2.295 2.295 0 0 0 4.09-.544c.125-.377.111-.807-.04-1.213Z"
        />
        <path
          fill="#D65A53"
          d="M.124 5.505a1.84 1.84 0 0 0-.04 1.212 2.295 2.295 0 0 0 4.091.545 2.293 2.293 0 0 0 3.825 0 2.293 2.293 0 0 0 3.825 0 2.295 2.295 0 0 0 4.09-.545c.125-.376.111-.807-.04-1.212l-.067-.18H.191l-.067.18Z"
        />
        <path
          fill="#D5D5D5"
          d="m15.875 5.504-1.212-3.257a1.152 1.152 0 0 0-1.075-.747h-2.439l.629 3.56c.03.176.046.354.046.533V7.26a2.295 2.295 0 0 0 4.091-.544c.125-.377.11-.807-.04-1.213Z"
        />
        <path
          fill="#E6E6E6"
          d="M11.825 5.593v1.669a2.294 2.294 0 0 0 4.09-.545c.125-.376.11-.807-.04-1.212l-.067-.18h-3.995c.007.09.011.178.011.268Z"
        />
        <path
          fill="#D5D5D5"
          d="M4.85 1.5 4.22 5.06a3.062 3.062 0 0 0-.046.533V7.26a2.294 2.294 0 0 0 3.825 0V1.5H4.85Z"
        />
        <path
          fill="#E6E6E6"
          d="M4.187 5.324a3.065 3.065 0 0 0-.012.268v1.669A2.293 2.293 0 0 0 8 7.26V5.324H4.187Z"
        />
        <path
          fill="#895438"
          d="M3.305 11.491a1.946 1.946 0 0 1 3.891 0v3.018H3.305V11.49ZM8.453 10.879c0-.736.597-1.333 1.333-1.333h1.575c.736 0 1.333.597 1.333 1.333v.519c0 .736-.597 1.332-1.333 1.332H9.786a1.333 1.333 0 0 1-1.333-1.332v-.52Z"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TreasureChestIcon({
  style,
}: {
  style?: React.CSSProperties | undefined;
}) {
  const clipPathId = useId();
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M31.1907 15.7304C30.9638 15.4659 30.6658 15.3155 30.3246 15.291C30.1866 15.2242 30.0136 15.1667 29.8044 15.0976C29.3405 14.9444 28.6394 14.7127 28.4871 14.3355C28.4564 14.2594 28.4229 14.1847 28.3881 14.1107L31.4628 7.63342L31.4625 7.6333C31.4857 7.58455 31.4991 7.53023 31.4991 7.47261V7.34548C31.4991 3.66179 28.5022 0.664795 24.8184 0.664795H7.18057C3.49682 0.664732 0.499878 3.66167 0.499878 7.34542V7.47254C0.499878 7.55029 0.523566 7.62254 0.564128 7.68242L3.58794 14.1585C3.56138 14.2169 3.53594 14.2757 3.51194 14.3353C3.35957 14.7127 2.6585 14.9443 2.19457 15.0975C1.98538 15.1666 1.81238 15.2242 1.67432 15.291C1.33313 15.3155 1.03519 15.4658 0.808253 15.7302C0.560066 16.0194 0.458566 16.3722 0.515066 16.7525L2.58613 30.254C2.68169 30.8804 3.21113 31.3351 3.84513 31.3351H28.1558C28.7889 31.3351 29.3176 30.8803 29.4129 30.254L31.4838 16.7532C31.5428 16.373 31.4411 16.0188 31.1908 15.7302L31.1907 15.7304Z"
          fill="#895438"
        />
        <path
          d="M24.8185 0.664734H7.18057C3.49682 0.664734 0.499878 3.66167 0.499878 7.34542V7.47255C0.499878 7.67961 0.667815 7.84755 0.874878 7.84755H31.1241C31.3311 7.84755 31.4991 7.67961 31.4991 7.47255V7.34542C31.4991 3.66173 28.5022 0.664734 24.8184 0.664734H24.8185Z"
          fill="#FFB432"
        />
        <path
          d="M24.8185 0.664734H7.1805C5.87544 0.664734 4.713 2.2448 3.98344 4.67448C3.91112 4.91523 4.09137 5.15811 4.34275 5.15811H27.6566C27.9079 5.15811 28.0881 4.91542 28.016 4.67467C27.2878 2.24486 26.1236 0.664734 24.8185 0.664734Z"
          fill="#895438"
        />
        <path
          d="M31.1241 7.84755H0.874875C0.745563 7.84755 0.6315 7.78205 0.564125 7.68243L3.58794 14.1586C3.99788 13.2587 4.70288 12.5167 5.50275 12.1525C6.36937 11.7577 7.29012 11.7719 8.35625 11.7879C8.82794 11.7951 9.31575 11.8024 9.85369 11.7777C10.1192 11.7652 10.3149 11.5928 10.6377 11.2893C11.2669 10.6977 12.1286 9.88761 14.3121 10.5224C15.4375 10.8507 16.5623 10.8507 17.6865 10.5225C19.871 9.88711 20.733 10.6979 21.3626 11.2898C21.6851 11.5931 21.8804 11.7652 22.1456 11.7777C22.6838 11.8025 23.1719 11.7951 23.6439 11.7879C24.7103 11.7718 25.6311 11.7578 26.4965 12.1527C27.2812 12.509 27.9747 13.2314 28.3881 14.1107L31.4628 7.63343L31.4625 7.6333C31.4023 7.75986 31.2736 7.84761 31.1241 7.84761L31.1241 7.84755Z"
          fill="#6C392C"
        />
        <path
          d="M13.2546 15.287V19.1919C13.2546 20.7059 14.4864 21.9377 16.0004 21.9377C17.5145 21.9377 18.7462 20.7059 18.7462 19.1919V15.287H13.2546Z"
          fill="#E6A22D"
        />
        <path
          d="M4.41681 3.45282H27.583C27.3414 2.87288 27.0707 2.36794 26.7769 1.95282H5.22281C4.92918 2.36794 4.6585 2.87288 4.41681 3.45282Z"
          fill="#6C392C"
        />
        <path
          d="M30.9473 20.2507C29.8978 20.0042 28.9446 19.4308 28.2312 18.608C27.4316 17.6857 26.9869 16.5082 26.9739 15.287H30.2249C30.6079 15.287 30.9419 15.4403 31.1908 15.7304C31.4411 16.0189 31.5429 16.3732 31.4838 16.7533L30.9473 20.2507ZM29.6748 26.3832C26.9324 26.3832 24.6991 28.5997 24.6696 31.3352H28.1558C28.7889 31.3352 29.3176 30.8804 29.4129 30.254L30.005 26.3942C29.8963 26.3874 29.7863 26.3832 29.6749 26.3832H29.6748ZM3.76781 18.608C4.56738 17.6857 5.01213 16.5082 5.02506 15.287H1.77413C1.39113 15.287 1.05713 15.4403 0.808314 15.7303C0.560127 16.0194 0.458627 16.3723 0.515127 16.7526L1.05169 20.2507C2.10125 20.0042 3.05438 19.4308 3.76781 18.6079V18.608ZM7.41713 31.315C7.41713 28.5544 5.17113 26.3084 2.41056 26.3084C2.26606 26.3084 2.12356 26.3149 1.98369 26.3265L2.58619 30.2542C2.68175 30.8806 3.21119 31.3353 3.84519 31.3353H7.42119L7.41725 31.315L7.41713 31.315Z"
          fill="#FFB432"
        />
        <path
          d="M8.6325 10.8695C8.41131 10.8695 8.19225 10.7721 8.04418 10.5853L7.36475 9.72775C7.1075 9.40313 7.16219 8.93144 7.48681 8.67419C7.81125 8.41694 8.28306 8.4715 8.54037 8.79625L9.21981 9.65375C9.47706 9.97838 9.42237 10.4501 9.09775 10.7073C8.96 10.8165 8.79562 10.8695 8.6325 10.8695Z"
          fill="#DDB926"
        />
        <path
          d="M23.3666 10.8695C23.2034 10.8695 23.0391 10.8165 22.9013 10.7073C22.5767 10.4501 22.522 9.97837 22.7793 9.65375L23.4586 8.79625C23.7158 8.47162 24.1876 8.417 24.5122 8.67418C24.8368 8.93137 24.8915 9.40312 24.6343 9.72775L23.9549 10.5852C23.8069 10.7721 23.5878 10.8695 23.3666 10.8695Z"
          fill="#DDB926"
        />
        <path
          d="M16.0004 19.9727C15.5862 19.9727 15.2504 19.6369 15.2504 19.2227V18.0001C15.2504 17.5859 15.5862 17.2501 16.0004 17.2501C16.4146 17.2501 16.7504 17.5859 16.7504 18.0001V19.2227C16.7504 19.6369 16.4146 19.9727 16.0004 19.9727Z"
          fill="#6C392C"
        />
        <path
          d="M6.64781 28.6531C7.13437 29.4248 7.41719 30.3373 7.41719 31.315L7.42112 31.3353H24.6696C24.6803 30.3464 24.9801 29.4261 25.4867 28.6531H6.64781Z"
          fill="#FFC83C"
        />
        <path
          d="M29.6748 26.3833C29.7863 26.3833 29.8963 26.3874 30.0049 26.3943L30.9473 20.2508C30.0013 20.0285 29.1343 19.5401 28.4499 18.8435L27.1926 27.0449C27.9247 26.6248 28.7718 26.3833 29.6748 26.3833Z"
          fill="#FFC83C"
        />
        <path
          d="M1.98369 26.3264C2.12356 26.3148 2.26613 26.3084 2.41056 26.3084C3.27031 26.3084 4.08006 26.5264 4.78769 26.9097L3.54925 18.8446L3.5485 18.8442C2.86419 19.5404 1.99744 20.0286 1.05169 20.2508L1.98369 26.3264Z"
          fill="#FFC83C"
        />
        <path
          d="M18.7462 17.9692H27.7603C27.2591 17.169 26.9841 16.2417 26.9739 15.287H18.7462V17.9692Z"
          fill="#FFC83C"
        />
        <path
          d="M13.2546 15.287H5.02513C5.015 16.2417 4.73994 17.169 4.23882 17.9692H13.2547L13.2546 15.287Z"
          fill="#FFC83C"
        />
        <path
          d="M4.61843 25.8079H27.3822L27.6122 24.3079H4.38812L4.61843 25.8079Z"
          fill="#6C392C"
        />
        <path
          d="M18.215 20.8126C17.7149 21.4941 16.9087 21.9376 16.0004 21.9376C15.0922 21.9376 14.2859 21.4941 13.7858 20.8126H3.85137L4.08175 22.3126H27.9181L28.148 20.8126H18.2149H18.215Z"
          fill="#6C392C"
        />
        <path
          d="M1.77412 15.2871H30.2249C30.2586 15.2871 30.2917 15.2887 30.3246 15.291C30.1866 15.2242 30.0136 15.1667 29.8044 15.0976C29.3405 14.9443 28.6394 14.7127 28.4871 14.3355C28.0917 13.355 27.3472 12.5389 26.4965 12.1526C25.6311 11.7577 24.7103 11.7717 23.6439 11.7879C23.1719 11.7951 22.6839 11.8024 22.1456 11.7777C21.8804 11.7652 21.6851 11.593 21.3626 11.2897C20.733 10.6978 19.871 9.88705 17.6865 10.5224C16.5624 10.8507 15.4376 10.8507 14.3121 10.5223C12.1286 9.88761 11.2669 10.6977 10.6377 11.2892C10.3149 11.5927 10.1192 11.7651 9.85368 11.7776C9.31575 11.8024 8.82793 11.795 8.35625 11.7878C7.29006 11.7718 6.36937 11.7577 5.50275 12.1524C4.65106 12.5402 3.90681 13.3563 3.51193 14.3352C3.35956 14.7126 2.6585 14.9442 2.19456 15.0975C1.98537 15.1666 1.81237 15.2241 1.67431 15.2909C1.70725 15.2886 1.74037 15.287 1.77406 15.287L1.77412 15.2871Z"
          fill="#FAD231"
        />
        <path
          d="M2.19463 15.0976C1.98544 15.1667 1.81244 15.2242 1.67438 15.2911C1.70731 15.2887 1.74044 15.2871 1.77413 15.2871H30.2249C30.2586 15.2871 30.2917 15.2887 30.3246 15.2911C30.1866 15.2242 30.0136 15.1667 29.8044 15.0976C29.3864 14.9595 28.777 14.7574 28.5489 14.4427H3.45006C3.22188 14.7574 2.61263 14.9596 2.19463 15.0976Z"
          fill="#DDB926"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
